import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import AppLayout from "./components/AppLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Quotes from "./pages/Quotes";
import QuoteBuilder from "./pages/QuoteBuilder";
import AdminUsers from "./pages/AdminUsers";
import AdminDealers from "./pages/AdminDealers";
import AdminPricelist from "./pages/AdminPricelist";
import AdminNoteTemplates from "./pages/AdminNoteTemplates";
import AdminSettings from "./pages/AdminSettings";
import MyCompany from "./pages/MyCompany";
import Customers from "./pages/Customers";
import ZaunPlaner from "./pages/ZaunPlaner";
import BalkonPlaner from "./pages/BalkonPlaner";
import SchiebetorPlaner from "./pages/SchiebetorPlaner";
import PublicQuote from "./pages/PublicQuote";
import PublicPlanner from "./pages/PublicPlanner";
import Inquiries from "./pages/Inquiries";
import "./index.css";

function ProtectedRoute({ children, requireAdmin }) {
  const { user, isAdmin } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-zinc-500">
        Wird geladen...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && !isAdmin) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/angebot/:token" element={<PublicQuote />} />
          <Route path="/zaunplaner" element={<PublicPlanner />} />
          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/quotes" element={<Quotes />} />
            <Route path="/quote/new" element={<QuoteBuilder />} />
            <Route path="/quote/:id" element={<QuoteBuilder />} />
            <Route path="/planner" element={<ZaunPlaner />} />
            <Route path="/balkon" element={<BalkonPlaner />} />
            <Route path="/schiebetor" element={<SchiebetorPlaner />} />
            <Route path="/customers" element={<Customers />} />
            <Route
              path="/admin/users"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminUsers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dealers"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminDealers />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/pricelist"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminPricelist />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/note-templates"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminNoteTemplates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/inquiries"
              element={
                <ProtectedRoute requireAdmin>
                  <Inquiries />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/settings"
              element={
                <ProtectedRoute requireAdmin>
                  <AdminSettings />
                </ProtectedRoute>
              }
            />
            <Route path="/meine-firma" element={<MyCompany />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
